import { useAuth } from '~/stores/auth'

export default defineNuxtRouteMiddleware(() => {
  const authStore = useAuth()

  if (!authStore.auth) {
    showError({ statusCode: 401 }) // doesn't work on SPA mode, error page not showing, navigation not preventing
  }
})
